export const isDevEnv = () => {
  const devEnvs = ['', 'development', 'dev', 'test', undefined];

  return (
    devEnvs.includes(window?.config?.env) ||
    devEnvs.includes(process.env.NODE_ENV)
  );
};
